import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API

export const contactUs = createAsyncThunk("fundraising/contactus", async (formData, thunkAPI) => {
  try {
    const res = await axios.post(
      `${BACKEND_URL}/api/v1/contact-us`,
      formData,
    );
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to contact");
  }
});

export const fetchFundraisingCategory = createAsyncThunk(
  'fundraising/fundraisingCategory',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/v1/campaign-details/${id}`);
      return res.data;
    } catch (error) {
      return rejectWithValue('Failed to fetch categories details');
    }
  }
);

const FundraisingSlice = createSlice({
  name: "fundraising",
  initialState: {
    fundraising: [],
    fundraisingCategories: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(contactUs.fulfilled, (state, action) => {
        state.fundraising.unshift(action.payload);
      })
      .addCase(fetchFundraisingCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFundraisingCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.fundraisingCategories = action.payload;
      })
      .addCase(fetchFundraisingCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch details data'
      });
  },
});

export default FundraisingSlice.reducer;